import type { SfBareItem } from './SfBareItem.js';
import type { SfInnerList } from './SfInnerList.js';
import type { SfItem } from './SfItem.js';

/**
 * A member of a structured field.
 *
 * @group Structured Field
 *
 * @beta
 */
export type SfMember = SfItem | SfInnerList | SfBareItem;
